module.exports = __webpack_public_path__ + "static/banner-footer-update-data-cl-MB-4d2130753ab7d87870388a8ea7826f8c.png";